import { http } from './../plugins/http/index';
import { getData } from './get';

// requests to API

export const postTelNumber = async (data) => http.post('/terminal/guide/send', data).then(getData);
export const fetchMapDataFromApi = async (mapId) => http.get(`/map-data/${mapId}`).then(getData);
export const fetchMapDataFromCDN = async (mapId) => http.get(`${process.env.VUE_APP_STORAGE_BASE_URL}${process.env.VUE_APP_MAP_DATA_URL}${mapId}.json`);
export const fetchMapDataLastModified = async (mapId) => http.head(`${process.env.VUE_APP_STORAGE_BASE_URL}${process.env.VUE_APP_MAP_DATA_URL}${mapId}.json`).then(
    (response) => response && response.headers && response.headers['last-modified'] && Date.parse(response.headers['last-modified'])
);
export const fetchTerminalData = async (terminalCode) => http.get(`/terminal/1.1/${terminalCode}`).then(getData).then(getData);

// --------------------------  viewApi  -----------------------------------------

export const currentOrientation = () => document.viewApi.camera_controller.current_orientation
export const getPointOnFloorScreenPos = (position, unitName) =>  document.viewApi.get_point_on_floor_screen_pos(position, unitName)
export const getStepTopScreenPos = activeGuideStepIndex => document.viewApi.get_step_top_screen_pos(activeGuideStepIndex)
export const getTargetScreenPos = (target, guideStepIndex) => document.viewApi[`get_${target}_screen_pos`](guideStepIndex)
